import { render } from "./CartFooterSummary.vue?vue&type=template&id=8956222e&scoped=true"
import script from "./CartFooterSummary.vue?vue&type=script&lang=js"
export * from "./CartFooterSummary.vue?vue&type=script&lang=js"

import "./CartFooterSummary.vue?vue&type=style&index=0&id=8956222e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/Gourmetta-RCS-Customer-Orders---Web-App/Gourmetta-RCS-Customer-Orders---Web-App/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8956222e"]])

export default __exports__